import { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";
import { firestore as db } from "../../../firebase/firebase"

const useTreatedPatient = ({ clinicId, date }) => {
  const [treatedPatients, setTreatedPatients] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribe: any;

    const setupRealtimeListener = async () => {
      try {
        // Create a reference to the patientAvailability collection
        const patientAvailabilityRef = collection(db, "patientAvailability");

        // Set up real-time listener with error handling and query filter
        unsubscribe = onSnapshot(
          query(
            patientAvailabilityRef,
            where("clinicId", "==", clinicId),
            where("appointmentDate", "==", date),
            where("roomStatus", "==", "ENDED")
          ),
          {
            next: (snapshot) => {
              // Handle collection changes
              const availabilityData = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
                timestamp: doc.data().timestamp?.toDate() || new Date(),
              }));

              // Sort by timestamp if available
              availabilityData.sort((a, b) => b.timestamp - a.timestamp);

              setTreatedPatients(availabilityData);
              setError("");
            },
            error: (err) => {
              console.error("Error in real-time listener:", err);
              setError(
                "Failed to sync with the database. Please refresh the page."
              );
            },
          }
        );
      } catch (err) {
        console.error("Error setting up listener:", err);
        setError("Failed to initialize real-time updates");
      }
    };

    setupRealtimeListener();

    // Cleanup function
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [date, clinicId]);

  return { treatedPatients, error };
};

export default useTreatedPatient;
